export { default as RCompraVenta } from './RCompraVenta';
export { default as RGanancia } from './RGanancia';
export { default as RCaja } from './RCaja';
export { default as RInventario } from './RInventario';
export { default as RDetalleCaja } from './DetalleCaja';
export { default as Rporpagar } from './Rporpagar';
export { default as RVencieminto } from './RVencimiento';
